import type { User as JiraRestUser } from '@atlassian/jira-shared-types/src/rest/jira/user.tsx';
import type { User } from '../../../domain/types.tsx';

export const transform = (user: JiraRestUser): User => ({
	email: user.emailAddress || '',
	name: user.displayName,
	userId: user.accountId,
	avatar: user.avatarUrls['48x48'],
});
